import { render, staticRenderFns } from "./AppTextareaLarge.vue?vue&type=template&id=4cbd79f2"
import script from "./AppTextareaLarge.vue?vue&type=script&lang=ts"
export * from "./AppTextareaLarge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports